import {
  EuiButtonEmpty,
  EuiContextMenuItem,
  EuiContextMenuPanel,
  EuiHorizontalRule,
  EuiIcon,
  EuiPopover,
  EuiText,
  EuiThemeProvider,
} from '@elastic/eui';
import { useAppContext } from '@lib/app-context';
import { signOut } from 'next-auth/react';
import { FC, useState } from 'react';

export const UserBadge: FC = () => {
  const [isPopoverOpen, setPopover] = useState(false);
  const { user } = useAppContext();

  const closePopover = () => {
    setPopover(false);
  };
  const badge = (
    <EuiThemeProvider colorMode="dark">
      <EuiButtonEmpty
        iconType="arrowDown"
        size="xs"
        color="text"
        css={{ padding: '0 6px' }}
        iconSide="right"
        onClick={() => setPopover(true)}>
        <EuiText size="s">{user.name}</EuiText>
      </EuiButtonEmpty>
    </EuiThemeProvider>
  );

  return (
    <EuiPopover
      button={badge}
      isOpen={isPopoverOpen}
      closePopover={closePopover}
      panelPaddingSize="none"
      anchorPosition="downRight">
      <EuiContextMenuPanel>
        <EuiContextMenuItem
          icon={<EuiIcon type="exit" />}
          onClick={() => {
            closePopover();
            signOut({ callbackUrl: 'https://login.voteda.org/logout' });
          }}>
          <EuiText size="s">Sign out</EuiText>
        </EuiContextMenuItem>
        <EuiHorizontalRule margin="none" />
        <EuiContextMenuItem disabled>
          <EuiText size="s" textAlign="right">
            Version: {process.env.NEXT_PUBLIC_VERSION ?? 'dev'}
          </EuiText>
        </EuiContextMenuItem>
      </EuiContextMenuPanel>
    </EuiPopover>
  );
};
